﻿import React, { useState, ChangeEvent, FormEvent } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '../../../../../temp/TextField';

export type SendEmailInputLabels = {
    placeholder: string;
    sendButton: string;
};

type SendEmailInputProps = {
    onSend: (email: string) => void;
    labels: SendEmailInputLabels;
    buttonDisabled?: boolean;
};

function SendEmailInput({ labels, onSend, buttonDisabled = false }: SendEmailInputProps) {
    let [email, setEmail] = useState<string>('');

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        setEmail(event.target.value);
    }

    function handleClickSend() {
        setEmail('');
        if (onSend && typeof onSend === 'function') {
            onSend(email);
        }
    }

    function handleSubmit(event: FormEvent) {
        event.preventDefault();
    }

    return (
        <form onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', padding: '8px 8px 4px 8px' }}>
                <TextField
                    placeholder={labels.placeholder}
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    sx={{
                        width: '100%'
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '4px 8px 8px 0' }}>
                <Button
                    type="button"
                    variant="contained"
                    disabled={!email || buttonDisabled}
                    onClick={handleClickSend}
                    color="primary"
                    sx={{ fontSize: '15px' }}
                >
                    {labels.sendButton}
                </Button>
            </Box>
        </form>
    );
}

export default SendEmailInput;
